export default "__VITE_ASSET__DL8Rk8uz__"